export const getOffset = (offsetString) => {
  if (offsetString === '+0' || offsetString === '-0' || offsetString === '0') {
    return 0
  }
  const parts = /^([+-])([0-9]?[0-9])([0-9][0-9])$/.exec(offsetString)
  const sign = parts[1]
  const hours = parseInt(sign + parts[2], 10)
  const minutes = parseInt(sign + parts[3], 10)
  return (hours * 3600) + (minutes * 60)
}

export const applyOffset = (time, offset) => ((time + offset + 86400) % 86400)



// WEBPACK FOOTER //
// ./src/utils/time.js